export default __webpack_public_path__ + "static/media/iconandlogo.097ad814.svg";